import Toolbar from "@mui/material/Toolbar";
import { baseURL, navbarContentArr } from "../../utils/StaticVariables";
import { useNavigate, useLocation } from "react-router-dom";
import {
  Box,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import { v4 as uuid } from "uuid";
import { useSetRecoilState } from "recoil";
import axios from "axios";
import { authState, featuresState, popupState } from "../../Recoil/RecoilState";
import { useSnackbar } from "notistack";
import { useRecoilValue } from "recoil";
import ThemeLogo from "../Reusable/ThemeLogo";



const ContentNav = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const setAuthRecoil = useSetRecoilState(authState);
  const setPopup = useSetRecoilState(popupState);
  const { enqueueSnackbar } = useSnackbar();
  const authRecoil = useRecoilValue(authState);
  const features = useRecoilValue(featuresState);
  const token = authRecoil?.token;

  const isSuperadmin = authRecoil?.role === "superadmin";

  // Filter items: superadminOnly needs superadmin role,
  // and feature-gated items need the feature enabled.
  const visibleNavbarContentArr = navbarContentArr.filter(
    (item) =>
      (!item.superadminOnly || isSuperadmin) &&
      (!item.feature || features === null || features.includes(item.feature))
  );


  const openPopup = () => {

    setPopup({
      isOpen: true,
      title: "Log out",
      content: "Are you sure you want to Log out ",
      sendReq: handelLogout,
    });
  };

  const handelLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("expire");
    setAuthRecoil(null);
    axios
      .post(baseURL, "logout", {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then(() => {
        enqueueSnackbar("you log out successfully", {
          variant: "success",
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const changeRouteHandel = (url) => {
    url ? navigate(url) : openPopup();
  };

  const isRouteActive = (url, path) => {
    if (!url) return false;
    if (url === "/") return path === "/";
    return path === url || path.startsWith(url);
  };

  const listStyle = (url, path) => ({
    borderRadius: 2,
    bgcolor: isRouteActive(url, path) && "primary.main",
    overflow: "hidden",
  });

  return (
    <Box sx={boxStyle}>
      <Toolbar sx={logoStyle} onClick={() => navigate("/")}>
        <ThemeLogo
          alt="logo"
          sx={{ width: "75%", margin: "10px auto" }}
        />
      </Toolbar>
      {visibleNavbarContentArr.map((el) => (
        <Box px={1} key={uuid()}>
          <List>
            <ListItem
              sx={listStyle(el.url, location.pathname)}
              key={el.url || el.text}
              disablePadding
              onClick={() => {
                changeRouteHandel(el.url);
              }}
            >
              <ListItemButton
                sx={{
                  justifyContent: "space-between",
                  display: "flex",
                }}
                selected={isRouteActive(el.url, location.pathname)}
              >
                <ListItemText primary={el.text} sx={{ textAlign: "start" }} />
                <ListItemIcon>{el.icon}</ListItemIcon>
              </ListItemButton>
            </ListItem>
          </List>
        </Box>
      ))}
    </Box>
  );
};

export default ContentNav;

const logoStyle = {
  cursor: "pointer",
};

const boxStyle = {
  height: "100vh",
  overflow: "auto",
};
